// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RocketOutlinedSvg from "@fishx/icons-svg/es/asn/RocketOutlined";
import FishxIcon from '../components/FishxIcon';

var RocketOutlined = function RocketOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RocketOutlinedSvg
  }));
};

RocketOutlined.displayName = 'RocketOutlined';
export default React.forwardRef(RocketOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RocketOutlined.js
// module id = 4038
// module chunks = 0